import { Header } from "../components/common/header/Header";
import { Outlet } from "react-router-dom";
import { Navbar } from "../components/common/navbar/Navbar";

export const Layout = () => {
  return (
    <div className="flex h-screen bg-gray-50">
      {/* Sidebar — fixed width 250px */}
      <div className="w-[250px] shrink-0 hidden lg:block">
        <Navbar />
      </div>
      {/* Main */}
      <div className="flex-1 flex flex-col min-w-0">
        <Header />
        <div className="flex-1 overflow-auto">
          <Outlet />
        </div>
      </div>
    </div>
  );
};
